const KEY = "anthm.connectorSignInResult";

/** The last connector sign-in result, kept briefly so what started it can act on it once. */
export function rememberSignInResult(result: string) {
  sessionStorage.setItem(KEY, JSON.stringify({ result, at: Date.now() }));
}

/** Takes (and clears) a result from the last minute, or null. */
export function takeSignInResult(): string | null {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  if (!raw) return null;
  try {
    const saved = JSON.parse(raw) as { result?: unknown; at?: unknown };
    if (typeof saved.result !== "string" || typeof saved.at !== "number") return null;
    return Date.now() - saved.at < 60_000 ? saved.result : null;
  } catch {
    return null;
  }
}
